export default __webpack_public_path__ + "static/home-8967c918ee009701f57f7e5fa94dad3a.webp";